module.exports = __webpack_public_path__ + "img/lb.ada52794.svg";